export default __webpack_public_path__ + "static/media/vertical_arrow.f052f6b9.svg";